import React from "react";

interface ProgressBarProps {
  value: number | null | undefined;
  completed?: boolean;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ value, completed }) => {
  const percent = value ? Math.min(Math.max(value, 0), 100) : 0;

  const barColor = completed
    ? "bg-[#3CA745]"
    : "bg-primary";

  return (
    <div className="relative h-4 w-full rounded-full bg-stroke dark:bg-strokedark overflow-hidden">

      {/* Barra rellena con texto adentro */}
      <div
        className={`h-full flex items-center justify-center ${barColor} transition-all duration-300`}
        style={{
          width: `${percent}%`,
          minWidth: percent > 0 ? "24px" : "0px", // ✅ Para que el texto nunca “se salga”
        }}
      >
        {percent > 0 && (
          <span className="text-[10px] font-bold text-white select-none leading-none">
            {percent}%
          </span>
        )}
      </div>

    </div>
  );
};

export default ProgressBar;
